import React from "react";
import { Eye, Factory, Sparkles, Zap, LineChart } from "lucide-react";
import { SectionHeading } from "./Section";
import { TiltCard, Reveal } from "../../lib/ui-motion";
import { useLang } from "../../i18n";

const ICONS = [Eye, Factory, Sparkles, Zap, LineChart];

export const Different = () => {
  const { t } = useLang();
  const d = t.different;

  return (
    <section className="relative py-24 md:py-36 bg-ink-surface/40" data-testid="different-section">
      <div className="mx-auto max-w-[1400px] px-6 md:px-12">
        <SectionHeading overline={d.overline} title={d.title} />

        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-5">
          {d.cards.map((c, i) => {
            const Icon = ICONS[i % ICONS.length];
            const featured = i === 0;
            return (
              <Reveal key={i} delay={i * 0.06} className={featured ? "md:col-span-2 md:row-span-1" : ""}>
                <TiltCard
                  max={6}
                  data-cursor="hover"
                  data-testid={`different-card-${i}`}
                  className="group relative h-full overflow-hidden rounded-3xl border border-white/10 bg-ink p-8 md:p-10 transition-colors duration-500 hover:border-flame/30"
                >
                  <div className="absolute -left-10 -bottom-10 h-40 w-40 rounded-full bg-flame/0 blur-3xl transition-all duration-500 group-hover:bg-flame/15" />
                  <span className="relative flex h-14 w-14 items-center justify-center rounded-2xl border border-white/10 bg-white/5 text-flame transition-colors group-hover:bg-flame group-hover:text-black">
                    <Icon size={24} />
                  </span>
                  <h3 className={`relative mt-6 font-heading font-bold ${featured ? "text-3xl md:text-4xl" : "text-2xl"}`}>{c.t}</h3>
                  <p className="relative mt-3 text-white/55 leading-relaxed max-w-md">{c.d}</p>
                </TiltCard>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
